module.exports = "<p class=\"mobileapp-notice\">\n    Now get OneApp: one application, one credit check, HERO and Benji results in minutes. <a href=\"#\" ng-click=\"main.applicationClick()\" analytics-on=\"click\" analytics-category=\"StartProject\" analytics-event=\"Banner Application Open\">Try it now</a> or <a href=\"https://raone.app/install\" target=\"_blank\" analytics-on=\"click\" analytics-category=\"StartProject\" analytics-event=\"Download mobile app click\">download mobile app &rsaquo;</a>\n</p>";


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/mobileAppNotice.html
// module id = 228
// module chunks = 1